import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const ProjectsLayout = () => {
  const navList = useNav();
  let { projectBottomNav, topProjectNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={projectBottomNav} topTabs={topProjectNav} />
      <Outlet />
    </div>
  );
};

export default ProjectsLayout;
